import { BANNER_STATUS_KEY } from "config/cookies";
import { setCookie, readCookie } from "utils/cookie";

export const showBanner = (showPopUp, req = null, res = null) =>
  setCookie(req, res, BANNER_STATUS_KEY, JSON.stringify({ showPopUp }));

export const shouldBannerShow = () =>
  JSON.parse(readCookie(BANNER_STATUS_KEY) || "{}");
